import React from 'react'
import PropTypes from 'prop-types'
import { Badge } from 'reactstrap'
import StringUtil from 'utils/string-util'
import { BANK_TRANSACTION_CASH_FLOWS } from 'domains/bank-transaction'

const propTypes = {
  status: PropTypes.string
}

const colorMap = {
  [BANK_TRANSACTION_CASH_FLOWS.CREDIT] : 'primary',
  [BANK_TRANSACTION_CASH_FLOWS.DEBIT]  : 'info'
}

/**
 * Display ::Finances::BankTransaction.cash_flow in Badge
 * @param {string} status
 */
const BankTransactionCashFlowBadge = ({ status }) => {
  const color = colorMap[status] || 'default'

  return (
    <Badge
      className='badge-lg'
      color={ color }
      pill
    >
      { StringUtil.humanizeUpperCase(status) }
    </Badge>
  )
}

BankTransactionCashFlowBadge.propTypes = propTypes

export default BankTransactionCashFlowBadge